/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ServiceAccountFeatureRequirementPerProvider {
    getFixupPrototypeFunction() { return ServiceAccountFeatureRequirementPerProvider.fixupPrototype; }

    static newInstance(model: Partial<ServiceAccountFeatureRequirementPerProvider>): ServiceAccountFeatureRequirementPerProvider {
        let obj = Object.assign(new ServiceAccountFeatureRequirementPerProvider(), model);
        ServiceAccountFeatureRequirementPerProvider.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ServiceAccountFeatureRequirementPerProvider>): ServiceAccountFeatureRequirementPerProvider {
        if (!model) return null;
        return ServiceAccountFeatureRequirementPerProvider.newInstance(<ServiceAccountFeatureRequirementPerProvider> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ServiceAccountFeatureRequirementPerProvider) {
        if (!obj) return;

        models.ServiceAccountFeatureRequirementPerProvider.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ServiceAccountFeatureRequirementPerProvider): boolean {
        Object.setPrototypeOf(obj, ServiceAccountFeatureRequirementPerProvider.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.provider) {
            models.ServiceAccountNativeDetailsBase.fixupPrototype(this.provider);
        }
        if (this.access_policies) {
            for (let val of this.access_policies) {
                models.ServiceAccountCloudAccessPolicy.fixupPrototype(val);
            }
        }
    }

    /**
     * Type of Provider this applies to
     */
    provider: models.ServiceAccountNativeDetailsBase;

    /**
     * List of sub-features that are always needed. They block onboarding until onboarded themselves.
     */
    mandatory_dependent_features: Array<models.ServiceAccountFeature>;

    /**
     * List of sub-features that can be optionally enabled. They don't block onboarding until onboarded themselves.
     */
    optional_dependent_features: Array<models.ServiceAccountFeature>;

    /**
     * List of sub-features that can be enabled after onboarding. They are included in access validation but don't directly participate in onboarding.
     */
    ondemand_dependent_features: Array<models.ServiceAccountFeature>;

    /**
     * Cloud Access Policies required for this Provider
     */
    access_policies: Array<models.ServiceAccountCloudAccessPolicy>;

}
